import Swiper, { Navigation, Pagination, Autoplay, Thumbs, FreeMode, Zoom} from 'swiper';
import { SwiperModule } from 'swiper/types/shared';

export default class SwiperElement {
    public swiperObj: Swiper = null; // Swiper element reference

    // Swiper Setup
    // documenation for swiper: https://swiperjs.com/swiper-api
    public allowSlideNext: boolean = true; // Set to false to disable swiping to next slide direction (to right or bottom)
    public allowSlidePrev: boolean = true; // Set to false to disable swiping to previous slide direction (to left or top)
    public autoHeight: boolean = false; // Set to true and slider wrapper will adapt its height to the height of the currently active slide
    public loopFillGroupWithBlank: boolean = false; // Enable and loop mode will fill groups with insufficient number of slides with blank slides. Good to be used with slidesPerGroup parameter
    public loop: boolean = false; // Set to true to enable continuous loop mode
    public pagination: Object | boolean = false;
    public navigation: Object | boolean = false;
    public watchSlidesProgress: boolean = false;
    public freeMode: Object | boolean = false;
    public centeredSlides: boolean = false; // If true, then active slide will be centered, not always on the left side.
    public slidesPerView: number | string = 1; // Number of slides per view (slides visible at the same time on slider's container).
    public slidesPerGroup: number = 1; // Set numbers of slides to define and enable group sliding. Useful to use with slidesPerView > 1
    public spaceBetween: number = 0; // Distance between slides in px.
    public speed: number = 300; // Duration of transition between slides (in ms)
    public longSwipes: boolean = true; // Set to false if you want to disable long swipes
    public width: null | number = null;
    public breakpoints: Object = null;
    public autoplay: Object | false = false;
    public modules: Array<SwiperModule> = [Navigation, Pagination, Autoplay];
    public thumbs: any | boolean = null;
    public loopedSlides: null | number = null;
    public zoom: boolean = false;
    public direction: string = 'horizontal'; // Standard value, can be changed to 'vertical'

    constructor(){}

    /**
     * @description creating Swiper Object
     * @param swiperClassSelector = specific string of the current swiper
     * @param swiperConfiguration = overridden configs from this class instance
     */
    public createSwiper (swiperClassSelector:string, swiperConfiguration:Object ){
        this.swiperObj = new Swiper( `.${swiperClassSelector}`, swiperConfiguration);
    }

    /**
     * @description way of adding some modules
     * @param swiperModule = name of the needed module
     */
    public addModule(swiperModule:string):void {
        switch(swiperModule) {
            case "Thumbs": this.modules.push(Thumbs); break;
            case "FreeMode": this.modules.push(FreeMode); break;
            case "Zoom": this.modules.push(Zoom); break;
            default: ""; break;
        }
    }
}